import CreateSeedAudiencesDataSources from './CreateSeedAudiencesDataSources.Container';

export default CreateSeedAudiencesDataSources;
